<template>
  <div class="action-buttons">
    <div class="action-btn ask-me" @click="$emit('open-chat')">
      <div class="icon">🎤</div>
      <span>点击问我</span>
    </div>
    <div class="action-btn overview" @click="$emit('open-map')">
      <div class="icon">🗺️</div>
      <span>商场总览</span>
    </div>
    <div class="action-btn find-brand" @click="$emit('open-brand-list')">
      <div class="icon">🔍</div>
      <span>找品牌</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionButtons'
}
</script>

<style scoped>
.action-buttons {
  display: flex;
  gap: 1.5vh;
  height: 100%;
}

.action-btn {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5vw;
  border-radius: 20px;
  font-size: 1.2rem; /* Reduced */
  font-weight: bold;
  color: #555;
  cursor: pointer;
  transition: transform 0.2s;
}

.action-btn:active {
  transform: scale(0.98);
}

.ask-me {
  background: #fdf5e6; /* Light yellowish */
  color: #8b7d6b;
}

.overview {
  background: #e6f7ff; /* Light blue */
  color: #1890ff;
}

.find-brand {
  background: #f0f8ff; /* Light bluish - maybe change to make distinct */
  color: #4682b4;
  background: #fff0f6; /* Light pinkish for brands */
  color: #eb2f96;
}

.icon {
  font-size: 1.5rem; /* Reduced */
}
</style>
